module.exports = __webpack_public_path__ + "img/logo.7bbfff5e.png";